import { api } from '../api';

const resource = '/menu';

const getAll = () => api.get(resource);
const getById = (id) => api.get(`${resource}/${id}`);
const create = (payload) => api.post(resource, payload);
const update = (id, payload) => api.put(`${resource}/${id}`, payload);
const remove = (id) => api.delete(`${resource}/${id}`);

export default {
  getAll,
  getById,
  create,
  update,
  remove,
};
